import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ProjectDto, CreateProjectInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CreateProjectApiResponse {
  success: boolean;
  data: ProjectDto;
}

/**
 * Mutation hook for creating a new project.
 * Calls POST /projects.
 * Invalidates the projects list on success.
 */
export function useCreateProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CreateProjectInput) => {
      const response = await apiClient.post<CreateProjectApiResponse>('/projects', input);
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.list() });
    },
  });
}
